import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { OnboardingMessageTemplateStatus } from '@community_dev/types/lib/api/OnboardingMessages'
import { Tag, Tooltip } from 'antd'

export const WhatsAppStatusTag = ({ status }: { status: OnboardingMessageTemplateStatus }) => {
  return (
    <>
      {status === OnboardingMessageTemplateStatus.APPROVED && (
        <Tag color="success" icon={<CheckCircleOutlined />}>
          Template Approved
        </Tag>
      )}
      {status === OnboardingMessageTemplateStatus.FAILED && (
        <Tooltip title="To re-submit, edit the message and click ”Save”">
          <Tag color="error" icon={<ExclamationCircleOutlined />}>
            Template Failed
          </Tag>
        </Tooltip>
      )}
      {status === OnboardingMessageTemplateStatus.PENDING && (
        <Tooltip title="Template is pending approval by Meta/WhatsApp. This can take up to several minutes.">
          <Tag color="warning" icon={<ExclamationCircleOutlined />}>
            Template Pending
          </Tag>
        </Tooltip>
      )}
      {status === OnboardingMessageTemplateStatus.REJECTED && (
        <Tooltip title="To re-submit, edit the message and click ”Save”">
          <Tag color="error" icon={<ExclamationCircleOutlined />}>
            Template Rejected
          </Tag>
        </Tooltip>
      )}
    </>
  )
}
